import { Component, Input } from '@angular/core';
import IMarketingChannels from '../../../_interfaces/IMarketingChannels';
import { FormBase } from '../../../_classes/form-base.class';
import { Observable } from 'rxjs';
import { MessageService } from 'primeng/api';
import { ValidatorService } from '../../../_services/validators/validator.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SessionService } from '../../../_services/session/session.service';
import { MarketingChannelsService } from '../../../_services/marketing-channels/marketing-channels.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { EResources } from '../../../_resources/EResources';
import { AdminFormActionsComponent } from '../../admin-ui/admin-form-actions/admin-form-actions.component';

@Component({
  selector: 'app-form-marketing-channel',
  imports: [
    TranslatePipe,

    FormsModule,
    CommonModule,
    InputTextModule,
    ButtonModule,
    AdminFormActionsComponent,
  ],
  templateUrl: './form-marketing-channel.component.html',
  styleUrl: './form-marketing-channel.component.scss',
})
export class FormMarketingChannelComponent extends FormBase<IMarketingChannels> {
  @Input() showIntro = true;
  public submitting = false;

  constructor(
    public messageService: MessageService,
    public validationService: ValidatorService,
    public marketingChannelService: MarketingChannelsService,
    public translate: TranslateService,
    public session: SessionService
  ) {
    super(session, messageService, translate);
  }

  clear(): void {
    this.payload = {
      name: '',
    };
  }
  generatePayload(): IMarketingChannels {
    return {
      name: this.payload.name,
    };
  }
  getResourceName(): string {
    return EResources.MARKETING_CHANNELS;
  }
  updateFn(payload: IMarketingChannels): Observable<any> {
    return this.marketingChannelService.update(
      this.customers_id,
      this.id,
      payload
    );
  }
  createFn(payload: IMarketingChannels): Observable<any> {
    return this.marketingChannelService.create(this.customers_id, payload);
  }
  properties(): string[] {
    return ['name'];
  }
  validate(): Promise<void> {
    return this.validationService.marketingChannel(this.payload);
  }

  override async execute(): Promise<void> {
    this.submitting = true;
    try {
      await super.execute();
    } finally {
      this.submitting = false;
    }
  }

  get formTitleKey(): string {
    return this.mode === 'edit'
      ? 'ADMIN.MARKETING.CHANNELS.ALL'
      : 'ADMIN.MARKETING.CHANNELS.ADD';
  }

  get formDescriptionKey(): string {
    return 'ADMIN.IA.MARKETING.DESCRIPTION';
  }
}
